const EVENT_PAYLOAD_SIZE_BYTES_LIMIT = 32 * 1024; // 32 KB

export { EVENT_PAYLOAD_SIZE_BYTES_LIMIT };
